import React from 'react'

interface HeadProps extends Omit<React.HTMLAttributes<HTMLTableSectionElement>, 'className'> {
  children: React.ReactNode;
}

export function Head ({ children, ...props }: HeadProps) {
  return <thead {...props} className='group/head'>{children}</thead>
}

Head.displayName = 'PlanTable.Head'
